<div class="width-1100">

  <mat-card>

    <mat-toolbar class="toolbar-top">

      <div class='title' style='padding: 10px;'>
        Nova Inscrição
      </div>

      <button mat-button (click)='goBack()'>
        <mat-icon>arrow_back</mat-icon>
      </button>

    </mat-toolbar>

  </mat-card>

  <div class='div-progress'>
    <mat-progress-bar [ngClass]="{hidden: !spinner}" color='primary' mode="indeterminate">
    </mat-progress-bar>
  </div>

  <div style="width: 500px; margin: auto;">

    <mat-card>

      <div class='congress-label'>{{_frontDeskService.currentProduct.name.trim().toUpperCase()}}</div>
      <div class='order-field'>Nome: {{_frontDeskService.currentMember.name}}</div>
      <div class='order-field'>Categoria: {{_frontDeskService.currentMember.subCategory.name}}</div>

      <div *ngIf="_frontDeskService.currentMember.obs" class='order-field-obs'>
        {{_frontDeskService.currentMember.obs}}
      </div>

    </mat-card>

    <mat-card *ngIf="isAnnuityFree">
      <!-- annuity free -->
      <div class="annuity-label">
        Situação: Isento
      </div>

      <div class="box-option"> <!-- *ngIf="value_total"-->

        <div class='order-line'>
          <div class='order-field-label'>
            Valor 
          </div>
          <div class='order-field-value-total'>
            R$ {{ value_total | currency:'BRL':'':'1.2-2'}}
          </div>
        </div>

        <button mat-raised-button (click)='createOrderAnnuityOk()' class='order-button'>
          Inscrição Simpósio BJCVS
        </button>

      </div>

    </mat-card>

    <mat-card *ngIf="!isAnnuityFree">
      <!--not annuity free -->

      <div *ngIf="haveDebts && op1_value_total && op2_value_total" class="box" >
        <!-- have debts -->
        <div class="annuity-label">
          Situação: Inadimplente
        </div>

        <div class="box-option">
          <!-- inscrição mais debitos -->
          <div class="box-debts">
            <div *ngFor="let annuity of annuities">
              <div>{{annuity.name}} - R$ {{annuity.price.value | currency:'BRL':'':'1.2-2'}}</div>
            </div>
          </div>

          <div class='order-line'>
            <div class='order-field-label'>
              Total Anuidades:
            </div>
            <div class='order-field-value'>
              R$ {{ totalDebit | currency:'BRL':'':'1.2-2'}}
            </div>
          </div>

          <div class='order-line'>
            <div class='order-field-label'>
              Inscrição:
            </div>
            <div class='order-field-value'>
              R$ {{ value_subscription | currency:'BRL':'':'1.2-2' }}
            </div>
          </div>

          <div class='order-line'>
            <div class='order-field-label'>
              Total
            </div>
            <div class='order-field-value-total'>
              R$ {{ op1_value_total | currency:'BRL':'':'1.2-2' }}
            </div>
          </div>

          <button mat-raised-button (click)='createOrderWithAnnuities()' class='order-button'>
            Inscrição Simpósio BJCVS + Anuidades Pendentes
          </button>

        </div>

        <div class="box-option">
          <!-- apenas inscrição -->

          <div class='order-line'>
            <div class='order-field-label'>
              Inscrição
            </div>
            <div class='order-field-value-total'>
              R$ {{ value_defaulting | currency:'BRL':'':'1.2-2'}}
            </div>
          </div>
          <div class='order-line'>
            <div class='order-field-label'>
              Total
            </div>
            <div class='order-field-value-total'>
              R$ {{ op2_value_total | currency:'BRL':'':'1.2-2'}}
            </div>
          </div>

          <button mat-raised-button (click)='createOrderWithoutAnnuities()' class='order-button'>
            Inscrição Simpósio BJCVS (Inadimplente)
          </button>

        </div>


      </div>

      <div *ngIf="!haveDebts && value_total">
        <!-- not have debts -->
        <div class="annuity-label">
          Situação: Adimplente
        </div>
        <div class="box-option">

          <div class='order-line'>
            <div class='order-field-label'>
              Valor 
            </div>
            <div class='order-field-value-total'>
              R$ {{ value_total | currency:'BRL':'':'1.2-2'}}
            </div>
          </div>

          <button mat-raised-button (click)='createOrderAnnuityOk()' class='order-button'>
            Inscrição Simpósio BJCVS
          </button>

        </div>

      </div>

    </mat-card>

  </div>

</div>

<br><br><br><br>